import type { VideoFile } from '@vimeo/gctl-api/models/components/schemas/video-file/VideoFile';

type TOptions = {
  allowDownloadOriginal?: boolean;
  allowAudioDownload?: boolean;
};

export const filterVideoFilesForKnownResolutionThenSortAlphabetically = (
  files: VideoFile[],
  options: TOptions = {},
): VideoFile[] => {
  const { allowDownloadOriginal = true, allowAudioDownload = false } = options;

  const getSortRank = (quality: VideoFile['quality']): number => {
    if (quality === 'source') return 0;
    if (quality === 'audio') return 2;
    return 1;
  };

  const allowedQualities: VideoFile['quality'][] = ['hd', 'sd', 'uhd'];
  if (allowAudioDownload) allowedQualities.push('audio');
  if (allowDownloadOriginal) allowedQualities.push('source');

  return files
    .filter((file) => allowedQualities.includes(file.quality))
    .sort((fileA, fileB) => {
      const rankA = getSortRank(fileA.quality);
      const rankDiff = rankA - getSortRank(fileB.quality);
      if (rankDiff !== 0) return rankDiff;
      return rankA === 1 ? fileB.height - fileA.height : 0;
    });
};
